(function () {
  'use strict';

  function initAuraaHeader(section) {
    if (!section || section.dataset.auraaHeaderReady === 'true') return;
    section.dataset.auraaHeaderReady = 'true';

    var wrapper = section.closest('.shopify-section');
    if (wrapper) wrapper.classList.add('auraa-header-shopify-wrapper');
    section.classList.add('is-sticky');

    var stickySpacer = null;
    var stickyResizeObserver = null;
    var stickyResizeHandler = null;

    function setupPersistentHeader() {
      if (!wrapper) return;

      var sectionId = section.dataset.sectionId || section.id || 'auraa-header';
      var spacerSelector = '[data-auraa-header-spacer="' + sectionId.replace(/"/g, '') + '"]';
      stickySpacer = wrapper.nextElementSibling;

      if (!stickySpacer || !stickySpacer.matches(spacerSelector)) {
        stickySpacer = document.createElement('div');
        stickySpacer.className = 'auraa-header-fixed-spacer';
        stickySpacer.setAttribute('data-auraa-header-spacer', sectionId);
        stickySpacer.setAttribute('aria-hidden', 'true');
        wrapper.insertAdjacentElement('afterend', stickySpacer);
      }

      function syncStickyHeight() {
        if (!section.isConnected || !stickySpacer || !stickySpacer.isConnected) return;
        var height = Math.ceil(section.getBoundingClientRect().height);
        if (!height) return;
        stickySpacer.style.setProperty('--auraa-fixed-header-height', height + 'px');
        stickySpacer.style.height = height + 'px';
      }

      stickyResizeHandler = syncStickyHeight;
      syncStickyHeight();
      window.requestAnimationFrame(syncStickyHeight);
      window.setTimeout(syncStickyHeight, 120);
      window.setTimeout(syncStickyHeight, 500);
      window.addEventListener('resize', syncStickyHeight, { passive: true });

      if ('ResizeObserver' in window) {
        stickyResizeObserver = new ResizeObserver(syncStickyHeight);
        stickyResizeObserver.observe(section);
      }
    }

    function cleanupPersistentHeader() {
      if (stickyResizeObserver) stickyResizeObserver.disconnect();
      if (stickyResizeHandler) window.removeEventListener('resize', stickyResizeHandler);
      if (stickySpacer && stickySpacer.parentNode) stickySpacer.parentNode.removeChild(stickySpacer);
      stickyResizeObserver = null;
      stickyResizeHandler = null;
      stickySpacer = null;
    }

    setupPersistentHeader();

    var menuToggle = section.querySelector('[data-auraa-menu-toggle]');
    var mobileMenu = section.querySelector('[data-auraa-mobile-menu]');
    var cartDrawer = section.querySelector('[data-auraa-cart-drawer]');
    var cartOverlay = section.querySelector('[data-auraa-cart-overlay]');
    var cartContent = section.querySelector('[data-auraa-cart-content]');
    var cartCount = section.querySelector('[data-auraa-cart-count]');
    var cartSubtotal = section.querySelector('[data-auraa-cart-subtotal]');
    var cartEstimatedTotal = section.querySelector('[data-auraa-cart-estimated-total]');
    var cartDeliveryDisplays = section.querySelectorAll('[data-auraa-cart-delivery]');
    var checkoutLink = section.querySelector('[data-auraa-checkout]');
    var cartOpenButtons = section.querySelectorAll('[data-auraa-cart-open]');
    var cartCloseButtons = section.querySelectorAll('[data-auraa-cart-close]');

    var currency = section.dataset.currency || 'USD';
    var deliveryPriceCents = Number(section.dataset.deliveryPriceCents || 0);
    var freeDeliveryQuantity = Math.max(1, Number(section.dataset.freeDeliveryQuantity || 3));
    var lastFocusedElement = null;
    var cartRequestInFlight = false;

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    function setDocumentClass(className, enabled) {
      document.documentElement.classList.toggle(className, enabled);
      document.body.classList.toggle(className, enabled);
    }

    function closeMenu() {
      if (!mobileMenu || !menuToggle) return;
      mobileMenu.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Open menu');
      setDocumentClass('auraa-menu-open', false);

      window.setTimeout(function () {
        if (!mobileMenu.classList.contains('is-open')) mobileMenu.hidden = true;
      }, 440);
    }

    function openMenu() {
      if (!mobileMenu || !menuToggle) return;
      closeCart(false);
      mobileMenu.hidden = false;

      window.requestAnimationFrame(function () {
        mobileMenu.classList.add('is-open');
        menuToggle.setAttribute('aria-expanded', 'true');
        menuToggle.setAttribute('aria-label', 'Close menu');
        setDocumentClass('auraa-menu-open', true);
      });
    }

    function toggleMenu() {
      if (!mobileMenu || !menuToggle) return;
      if (mobileMenu.classList.contains('is-open')) closeMenu();
      else openMenu();
    }

    function setCartLoading(loading) {
      if (!cartDrawer) return;
      cartDrawer.classList.toggle('is-loading', Boolean(loading));
    }

    async function fetchCart() {
      var response = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Unable to load cart.');
      return response.json();
    }

    function updateCartCount(cart) {
      if (!cartCount) return;
      var count = Number(cart && cart.item_count ? cart.item_count : 0);
      cartCount.textContent = String(count);
      cartCount.classList.toggle('is-empty', count === 0);
    }

    function createEmptyCart() {
      var empty = document.createElement('div');
      empty.className = 'auraa-cart-empty';

      var mark = document.createElement('div');
      mark.className = 'auraa-cart-empty__mark';
      mark.textContent = 'A';

      var title = document.createElement('h3');
      title.textContent = 'YOUR RITUAL AWAITS';

      var text = document.createElement('p');
      text.textContent = 'Your bag is empty. Add AURAA COFFEE and make the next cup count.';

      empty.appendChild(mark);
      empty.appendChild(title);
      empty.appendChild(text);
      return empty;
    }

    function createCartItem(item, line) {
      var article = document.createElement('article');
      article.className = 'auraa-cart-item';

      var imageLink = document.createElement('a');
      imageLink.className = 'auraa-cart-item__image-link';
      imageLink.href = item.url || '#';

      if (item.image) {
        var image = document.createElement('img');
        image.className = 'auraa-cart-item__image';
        image.src = item.image;
        image.alt = item.product_title || item.title || 'Cart item';
        image.loading = 'lazy';
        image.width = 184;
        image.height = 220;
        imageLink.appendChild(image);
      }

      var main = document.createElement('div');
      main.className = 'auraa-cart-item__main';

      var top = document.createElement('div');
      top.className = 'auraa-cart-item__top';

      var titleLink = document.createElement('a');
      titleLink.className = 'auraa-cart-item__title';
      titleLink.href = item.url || '#';
      titleLink.textContent = item.product_title || item.title || 'Product';

      var price = document.createElement('span');
      price.className = 'auraa-cart-item__price';
      price.textContent = formatMoney(item.final_line_price);

      top.appendChild(titleLink);
      top.appendChild(price);
      main.appendChild(top);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variant = document.createElement('p');
        variant.className = 'auraa-cart-item__variant';
        variant.textContent = item.variant_title;
        main.appendChild(variant);
      }

      var bottom = document.createElement('div');
      bottom.className = 'auraa-cart-item__bottom';

      var quantity = document.createElement('div');
      quantity.className = 'auraa-cart-item__quantity';
      quantity.setAttribute('aria-label', 'Quantity');

      var minus = document.createElement('button');
      minus.type = 'button';
      minus.textContent = '-';
      minus.setAttribute('aria-label', 'Decrease quantity');
      minus.addEventListener('click', function () {
        changeCartLine(line, Math.max(0, Number(item.quantity) - 1));
      });

      var number = document.createElement('span');
      number.textContent = String(item.quantity);
      number.setAttribute('aria-live', 'polite');

      var plus = document.createElement('button');
      plus.type = 'button';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'Increase quantity');
      plus.addEventListener('click', function () {
        changeCartLine(line, Number(item.quantity) + 1);
      });

      quantity.appendChild(minus);
      quantity.appendChild(number);
      quantity.appendChild(plus);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'auraa-cart-item__remove';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () {
        changeCartLine(line, 0);
      });

      bottom.appendChild(quantity);
      bottom.appendChild(remove);
      main.appendChild(bottom);

      article.appendChild(imageLink);
      article.appendChild(main);
      return article;
    }

    function renderCart(cart) {
      if (!cartContent) return;
      cartContent.innerHTML = '';

      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
        cartContent.appendChild(createEmptyCart());
      } else {
        cart.items.forEach(function (item, index) {
          cartContent.appendChild(createCartItem(item, index + 1));
        });
      }

      updateCartCount(cart);

      var itemCount = Number(cart && cart.item_count ? cart.item_count : 0);
      var qualifiesForFreeDelivery = itemCount >= freeDeliveryQuantity;
      var appliedDeliveryCents = itemCount > 0 && !qualifiesForFreeDelivery ? deliveryPriceCents : 0;

      if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price || 0);

      cartDeliveryDisplays.forEach(function (deliveryDisplay) {
        deliveryDisplay.textContent = qualifiesForFreeDelivery ? 'FREE DELIVERY' : formatMoney(deliveryPriceCents);
        deliveryDisplay.classList.toggle('is-free', qualifiesForFreeDelivery);
      });

      if (cartEstimatedTotal) {
        var estimated = Number(cart.total_price || 0) + appliedDeliveryCents;
        cartEstimatedTotal.textContent = formatMoney(estimated);
      }

      if (checkoutLink) checkoutLink.classList.toggle('is-disabled', !cart.item_count);
    }

    async function refreshCart() {
      if (cartRequestInFlight) return null;
      cartRequestInFlight = true;
      setCartLoading(true);

      try {
        var cart = await fetchCart();
        renderCart(cart);
        return cart;
      } catch (error) {
        console.error('AURAA cart refresh error:', error);
        return null;
      } finally {
        cartRequestInFlight = false;
        setCartLoading(false);
      }
    }

    async function changeCartLine(line, quantity) {
      if (cartRequestInFlight) return;
      cartRequestInFlight = true;
      setCartLoading(true);

      try {
        var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
        var response = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ line: line, quantity: quantity })
        });

        var cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message || 'Unable to update cart.');

        renderCart(cart);
        publishCartUpdate(cart);
      } catch (error) {
        console.error('AURAA cart update error:', error);
        await refreshCart();
      } finally {
        cartRequestInFlight = false;
        setCartLoading(false);
      }
    }

    function publishCartUpdate(cart) {
      try {
        document.dispatchEvent(new CustomEvent('auraa:cart:updated', { detail: { cart: cart } }));
      } catch (error) {
        // Custom events are optional compatibility helpers.
      }

      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'auraa-header',
            cartData: cart
          });
        }
      } catch (error) {
        // Dawn pub/sub is optional; the AURAA cart remains the source of truth here.
      }
    }

    async function addToCart(variantId, quantity, properties) {
      var id = Number(variantId);
      var qty = Math.max(1, Number(quantity || 1));
      if (!id) throw new Error('A valid Shopify variant is required.');

      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      var item = { id: id, quantity: qty };
      if (properties && typeof properties === 'object') item.properties = properties;

      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [item] })
      });

      var data = await response.json().catch(function () { return {}; });
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add product.');

      var cart = await refreshCart();
      publishCartUpdate(cart || data);
      await openCart(false);
      return data;
    }

    async function openCart(refreshFirst) {
      if (!cartDrawer || !cartOverlay) return;
      closeMenu();
      lastFocusedElement = document.activeElement;

      cartOverlay.hidden = false;
      cartDrawer.setAttribute('aria-hidden', 'false');

      window.requestAnimationFrame(function () {
        cartOverlay.classList.add('is-open');
        cartDrawer.classList.add('is-open');
        setDocumentClass('auraa-cart-open', true);
      });

      if (refreshFirst !== false) await refreshCart();

      var closeButton = cartDrawer.querySelector('[data-auraa-cart-close]');
      if (closeButton) closeButton.focus({ preventScroll: true });

      try {
        document.dispatchEvent(new CustomEvent('auraa:cart:open'));
      } catch (error) {
        // Optional compatibility event.
      }
    }

    function closeCart(returnFocus) {
      if (!cartDrawer || !cartOverlay) return;
      cartOverlay.classList.remove('is-open');
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      setDocumentClass('auraa-cart-open', false);

      window.setTimeout(function () {
        if (!cartOverlay.classList.contains('is-open')) cartOverlay.hidden = true;
      }, 260);

      if (returnFocus !== false && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus({ preventScroll: true });
      }

      try {
        document.dispatchEvent(new CustomEvent('auraa:cart:close'));
      } catch (error) {
        // Optional compatibility event.
      }
    }

    function handleKeydown(event) {
      if (event.key !== 'Escape') return;
      if (cartDrawer && cartDrawer.classList.contains('is-open')) {
        event.preventDefault();
        closeCart(true);
        return;
      }
      if (mobileMenu && mobileMenu.classList.contains('is-open')) {
        event.preventDefault();
        closeMenu();
      }
    }

    if (menuToggle) menuToggle.addEventListener('click', toggleMenu);

    if (mobileMenu) {
      mobileMenu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
    }

    cartOpenButtons.forEach(function (button) {
      button.addEventListener('click', function () { openCart(true); });
    });

    cartCloseButtons.forEach(function (button) {
      button.addEventListener('click', function () { closeCart(true); });
    });

    if (cartOverlay) cartOverlay.addEventListener('click', function () { closeCart(true); });
    document.addEventListener('keydown', handleKeydown);

    document.addEventListener('auraa:cart:updated', function (event) {
      if (event.detail && event.detail.cart && Array.isArray(event.detail.cart.items)) {
        renderCart(event.detail.cart);
      } else {
        refreshCart();
      }
    });

    window.addEventListener('pageshow', function () {
      refreshCart();
      if (stickyResizeHandler) stickyResizeHandler();
    });

    section.addEventListener('shopify:section:unload', cleanupPersistentHeader, { once: true });

    window.AuraaCart = window.AuraaCart || {};
    window.AuraaCart.open = function () { return openCart(true); };
    window.AuraaCart.close = function () { return closeCart(true); };
    window.AuraaCart.refresh = refreshCart;
    window.AuraaCart.add = addToCart;

    window.openAuraaCartDrawer = function () { return openCart(true); };
    window.closeAuraaCartDrawer = function () { return closeCart(true); };
    window.refreshAuraaCart = refreshCart;

    refreshCart();
  }

  function initAllAuraaHeaders(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-auraa-header]').forEach(initAuraaHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllAuraaHeaders(document); });
  } else {
    initAllAuraaHeaders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllAuraaHeaders(event.target);
  });
})();